import { render, staticRenderFns } from "./WarehouseListTable.vue?vue&type=template&id=04b51f88&scoped=true"
import script from "./WarehouseListTable.vue?vue&type=script&lang=js"
export * from "./WarehouseListTable.vue?vue&type=script&lang=js"
import style0 from "./WarehouseListTable.vue?vue&type=style&index=0&id=04b51f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b51f88",
  null
  
)

export default component.exports